<template>
    <v-row>
        <v-col cols="3" style="margin-left: 10px;">
            <v-text-field
                v-model="searchTermConfig"
                label="Filtrar dispositivos"
                outlined
                dense
                hide-details
                prepend-inner-icon="mdi-magnify"
                class="mb-2"
            ></v-text-field>
            <div style="max-height: 80vh; overflow-y: auto;">
                <v-treeview
                    v-model="tree"
                    :active.sync="selection"
                    :items="devicesTree"
                    :search="searchTermConfig"
                    activatable
                >
                    <template v-slot:prepend="{ item, open }">
                        <v-icon v-if="!item.type" :color="iconColor(open)">
                            {{ 'mdi-desktop-classic' }}
                        </v-icon>
                        <v-icon v-else>
                            {{ 'mdi-overscan' }}
                        </v-icon>
                    </template>
                </v-treeview>
            </div>
        </v-col>
        <v-divider vertical></v-divider>
        <v-scroll-y-transition mode="out-in">
            <div v-if="formType == ''">
                
            </div>
            <v-col cols="8" v-else-if="formType == 'device'">
                <v-card outlined class="mx-auto" max-width="600">
                    <v-card-subtitle class="d-flex justify-space-between align-center">
                      <span class="text-subtitle-1 font-weight-medium">
                        Dispositivo {{ updateDevice.name }}
                      </span>
                      <v-switch
                        v-model="updateDevice.view"
                        inset
                        :label="updateDevice.view ? 'Activo' : 'Inactivo'"
                        class="ma-0"
                        color="success"
                        hide-details
                        dense
                      ></v-switch>
                    </v-card-subtitle>
                    <v-card-actions>
                    <v-row>
                            <v-col cols="12" sm="12">
                                <v-text-field
                                    v-model="updateDevice.name"
                                    outlined
                                    dense
                                    label="Nombre"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" v-show="hasImagen">
                                <v-card>
                                    <v-img
                                        :src="imageUrl"
                                        max-height="125"
                                        max-width="580"
                                        contain
                                        class="white"
                                    ></v-img>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-file-input
                                    label="Imagen"
                                    prepend-icon="mdi-camera"
                                    outlined
                                    dense
                                    show-size
                                    accept="image/*"
                                    v-model="fileImage"
                                    @change="uploadImage"
                                ></v-file-input>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-badge
                                    bordered
                                    :color="deviceColor"
                                    overlap
                                >
                                    <v-text-field
                                        v-model="deviceColor"
                                        outlined
                                        dense
                                        label="Color"
                                        readonly
                                        @click="viewColorSelector()"
                                    >
                                    </v-text-field>
                                </v-badge>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field
                                    v-model.number="displayRank"
                                    outlined
                                    dense
                                    :rules="[rules.min, rules.max]"
                                    type="number"
                                    label="Prioridad"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12">
                                <v-text-field
                                    v-model="updateDevice.info.description"
                                    outlined
                                    dense
                                    label="Descripcion"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateDevice.address.ip"
                                    outlined
                                    dense
                                    label="Direccion IP"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateDevice.address.mac"
                                    outlined
                                    dense
                                    label="Direccion MAC"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model.number="updateDevice.location.lat"
                                    outlined
                                    dense
                                    type="number"
                                    label="Localización Latitud"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model.number="updateDevice.location.lng"
                                    outlined
                                    dense
                                    type="number"
                                    label="Localización Longitud"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateDevice.laeqFilter.max"
                                    outlined
                                    dense
                                    label="Filtro Laeq Maximo"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateDevice.laeqFilter.min"
                                    outlined
                                    dense
                                    label="Filtro Laeq Minimo"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12">
                                <v-switch
                                    v-model="optionsDevices.autoYaxis"
                                    :label="autoYaxisLabel"
                                    color="success"
                                    hide-details
                                    inset
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="optionsDevices.yaxisValue.max"
                                    outlined
                                    dense
                                    clearable
                                    :disabled="optionsDevices.autoYaxis"
                                    :rules="[rulesYaxis.max]"
                                    type="number"
                                    label="Valor Maximo"
                                    hint="Valor maximo para el eje Y"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="optionsDevices.yaxisValue.min"
                                    outlined
                                    dense
                                    clearable
                                    :disabled="optionsDevices.autoYaxis"
                                    :rules="[
                                      rulesYaxis.min,
                                      v => rules.minWithMax(v, optionsDevices.yaxisValue.max)
                                    ]"
                                    type="number"
                                    label="Valor Minimo"
                                    hint="Valor minimo para el eje Y"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12">
                                <v-switch
                                    v-model="optionsDevices.autoTrendYaxis"
                                    :label="autoTrendYaxisLabel"
                                    color="success"
                                    hide-details
                                    inset
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="optionsDevices.trendYaxisValue.max"
                                    outlined
                                    dense
                                    clearable
                                    :disabled="optionsDevices.autoTrendYaxis"
                                    :rules="[rulesYaxis.max]"
                                    type="number"
                                    label="Valor Maximo"
                                    hint="Valor maximo para el eje Y"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="optionsDevices.trendYaxisValue.min"
                                    outlined
                                    dense
                                    clearable
                                    :disabled="optionsDevices.autoTrendYaxis"
                                    :rules="[
                                      rulesYaxis.min,
                                      v => rules.minWithMax(v, optionsDevices.trendYaxisValue.max)
                                    ]"
                                    type="number"
                                    label="Valor Minimo"
                                    hint="Valor minimo para el eje Y"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" class="text-right">
                                <v-btn
                                    outlined
                                    color="green"
                                    dark
                                    @click="updateData"
                                >
                                    Actualizar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="8" v-else>
                <v-card outlined class="mx-auto" max-width="600">
                    <v-card-subtitle class="text-subtitle-1 font-weight-medium" style="margin-bottom: -25px;">
                        Dispositivo {{sensorDeviceName}} / Sensor {{updateSensor.sensorName}}
                    </v-card-subtitle>
                    <v-card-actions>
                    <v-row>
                            <v-col cols="12" sm="12">
                                <v-switch
                                    v-model="updateSensor.viewUser"
                                    :label="viewUserLabel"
                                    color="success"
                                    hide-details
                                    inset
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.sensorName"
                                    outlined
                                    dense
                                    readonly
                                    label="Nombre"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.sensorType"
                                    outlined
                                    dense
                                    readonly
                                    label="Tipo"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.description"
                                    outlined
                                    dense
                                    label="Descripcion"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.unit"
                                    outlined
                                    dense
                                    label="Unidad de medida"
                                    hint="Ej, [m]"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12">
                                <v-switch
                                    v-model="updateSensor.complianceLimits.enabled"
                                    :label="complianceLimitsLabel"
                                    color="success"
                                    hide-details
                                    inset
                                ></v-switch>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.complianceLimits.red"
                                    outlined
                                    dense
                                    clearable
                                    type="number"
                                    label="Umbral de alerta roja dia"
                                    hint="Umbral para activar la alerta roja"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.complianceLimits.yellow"
                                    outlined
                                    dense
                                    clearable
                                    type="number"
                                    label="Umbral de alerta amarilla dia"
                                    hint="Umbral para activar la alerta amarilla"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.complianceLimits.redNight"
                                    outlined
                                    dense
                                    clearable
                                    type="number"
                                    label="Umbral de alerta roja nocturno"
                                    hint="Umbral para activar la alerta roja"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.complianceLimits.yellowNight"
                                    outlined
                                    dense
                                    clearable
                                    type="number"
                                    label="Umbral de alerta amarilla nocturno"
                                    hint="Umbral para activar la alerta amarilla"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12">
                                <v-switch
                                    v-model="updateSensor.hasEvents"
                                    :label="hasEventLabel"
                                    color="success"
                                    hide-details
                                    inset
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.highThreshold"
                                    outlined
                                    dense
                                    clearable
                                    :disabled="!updateSensor.hasEvents"
                                    type="number"
                                    label="Umbral Maximo"
                                    hint="Umbral en que se activa el evento"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.lowThreshold"
                                    outlined
                                    dense
                                    clearable
                                    :disabled="!updateSensor.hasEvents"
                                    type="number"
                                    label="Umbral Minimo"
                                    hint="Umbral en que se activa el evento"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="updateSensor.offset"
                                    outlined
                                    dense
                                    clearable
                                    type="number"
                                    label="Offset"
                                    hint="Agregar un offset a los datos sensados"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" class="text-right">
                                <v-btn
                                    outlined
                                    color="green"
                                    @click="updateData"
                                    dark
                                >
                                    Actualizar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-scroll-y-transition>
        <v-row>
            <v-dialog v-model="loadingUpdateImage" hide-overlay persistent width="300">
                <v-card color="green" dark>
                    <v-card-text>
                        Subiendo Imagen
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog
                v-model="colorSelector"
                width="300"
            >
                <v-card>
                    <v-card-title>
						<span class="text-h5">Seleccionar color</span>
					</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-color-picker
                                    v-model="selectColor"
                                    mode.sync="hex"
                                    flat
                                ></v-color-picker>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
   
                        <v-btn
                            color="primary"
                            @click="cancelColor()"
                        >
                            Cancelar
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="setColor()"
                        >
                            Aceptar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-row>
</template>

<script>
    import axios from 'axios'
    import authHeader from '../../services/authHeader';

  export default {
    name: 'DevicesConfig',

    data: () => ({
        devicesTree: [],
        searchTermConfig: '',
        formType: '',
        updateDevice: {
            address: {
                ip: '',
                mac: ''
            },
            location: {
                lat: 0,
                lng: 0
            },
            info: {
                description: '',
                image: ''
            },
            deviceImage: null
        },
        optionsDevices: {
            deviceId: '',
            autoYaxis: true,
            autoTrendYaxis: true,
            yaxisValue: {
                max: 100,
                min: 0
            },
            trendYaxisValue: {
                max: 100,
                min: 0
            }
        },
        updateSensor: {},
        color: 'primary',
        files: {
            html: 'mdi-language-html5',
            js: 'mdi-nodejs',
            json: 'mdi-code-json',
            md: 'mdi-language-markdown',
            pdf: 'mdi-file-pdf',
            png: 'mdi-file-image',
            txt: 'mdi-file-document-outline',
            xls: 'mdi-file-excel',
        },
        tree: [],
        selection: [],
        fileImage: null,
        loadingUpdateImage: false,
        colorSelector: false,
        imageUrl: '',
        selectColor: '',
        deviceColor: '',
        displayRank: 1,
        rules: {
            min: v => v >= 1 || 'Valor minimo 1',
            max: v => v <= 10 || 'Valor maximo 10',
            minWithMax: (v, max) => v <= max || `El valor mínimo no puede superar a ${max}`,
        },
        rulesYaxis: {
            min: v => v >= 0 || 'Valor minimo 0',
            max: v => v <= 100 || 'Valor maximo 100',
        },
    }),

    computed: {
        devices () {
            return this.$store.getters.devices
        },
        
        optionsAllDevices () {
            return this.$store.getters.optionsDevices
        },

        sensors () {
            return this.$store.getters.allSensors
        },

        sensorDeviceName () {
            return this.devices.find( e => {
                return e.deviceId === this.updateSensor.deviceId
            }).name
        },

        viewUserLabel () {
            return this.updateSensor.viewUser ? 'Sensor visible para todos' : 'Sensor visible solo administracion'
        },

        hasEventLabel () {
            return this.updateSensor.hasEvents ? 'Eventos activados' : 'Eventos desactivados'
        },

        complianceLimitsLabel () {
            return this.updateSensor.complianceLimits.enabled ? 'Mostrar umbrales de alerta' : 'Ocultar umbrales de alerta'
        },

        uriServer() {
            return this.$store.getters.uri
        },

        hasImagen () {
            return this.imageUrl.length > 0
        },
        
        autoYaxisLabel () {
            return this.optionsDevices.autoYaxis ? 'Auto valor maximo y minimo Laeq' : 'Valor maximo y minimo Laeq'
        },

        autoYaxisIsValid () {
            const { yaxisValue } = this.optionsDevices
            return yaxisValue.max <= 100 && yaxisValue.min >= 0 && yaxisValue.min <= yaxisValue.max
        },

        autoTrendYaxisLabel () {
            return this.optionsDevices.autoTrendYaxis ? 'Auto valor maximo y minimo Tendencia' : 'Valor maximo y minimo Tendencia'
        },

        autoTrendYaxisIsValid () {
            const { trendYaxisValue } = this.optionsDevices
            return trendYaxisValue.max <= 100 && trendYaxisValue.min >= 0 && trendYaxisValue.min <= trendYaxisValue.max
        },
    },

    methods: {
        iconColor (isOpen) {
            return isOpen ? 'primary' : ''
        },

        createDeviceTree (sensor) {
            let items = []
            let children = {}

            for (let i = 0; i < sensor.length; i++) {
                const element = sensor[i]

                if (!Object.hasOwnProperty.call(children, element.deviceId))
                    children[element.deviceId] = []

                children[element.deviceId].push({
                    id: element._id,
                    name: element.sensorName,
                    type: element.sensorType
                })
            }
            
            for (const key in children) {
                if (Object.hasOwnProperty.call(children, key)) {
                    const element = children[key]
                    const device = this.devices.find( e => e.deviceId === key)
                    
                    items.push({
                        id: device._id,
                        name: device.name,
                        children: element
                    })
                }
            }

            this.devicesTree = items
        },

        selectType (id) {
            const findDevice = this.devices.filter( e => {
                return e._id === id[0]
            })
            
            if (findDevice.length > 0) {
                this.formType = 'device'
                this.updateDevice = findDevice[0]

                if (!Object.hasOwnProperty.call(this.updateDevice, "laeqFilter")) {
                    this.updateDevice.laeqFilter = {
                        max: 90,
                        min: 45
                    }
                }
                
                if (!Object.hasOwnProperty.call(this.updateDevice, "location")) {
                    this.updateDevice.location = {
                        lat: 0,
                        lng: 0
                    }
                }

                if (!Object.hasOwnProperty.call(this.updateDevice, "info")) {
                    this.updateDevice.info = {
                        description: '',
                        image: ''
                    }
                }
            }

            const { info } = this.updateDevice

            this.fileImage = null
            this.deviceColor = info.color ? info.color : '#FFFFFF'
            this.displayRank = info.displayRank ? info.displayRank : 1
            this.imageUrl = info.image ? info.image : ''

            const findSensor = this.sensors.filter( e => {
                return e._id === id[0]
            })

            if (findSensor.length > 0) {
                this.formType = 'sensor'
                this.updateSensor = findSensor[0]
            }
        },

        setOptionsDevices (id) {
            const findDevice = this.devices.find( e => {
                return e._id === id[0]
            })

            const findDeviceOptions = this.optionsAllDevices.find( e => {
                return e.deviceId === findDevice.deviceId
            })
            
            if (findDeviceOptions) {
                this.optionsDevices = findDeviceOptions
            }
        },

        updateData () {
            if (this.formType === 'device') {
                if (!this.autoYaxisIsValid)
                    return
                
                this.$store.dispatch('updateDevice', this.updateDevice)
                this.$store.dispatch('updateOptionsDevices', this.optionsDevices)
            }

            if (this.formType === 'sensor') {
                this.$store.dispatch('updateSensor', this.updateSensor)
            }
        },

        uploadImage() {
            if (!this.fileImage)
                return

            const formData = new FormData()
            formData.append('image', this.fileImage)

            const url = `${this.uriServer}/device/${this.updateDevice.deviceId}/image`
            
            this.loadingUpdateImage = true
            axios
            .post(url, formData, { headers: {...authHeader(), 'Content-Type': 'multipart/form-data' } })
            .then(response => {
                this.imageUrl = response.data.imageUrl
                this.updateDevice.info.image = response.data.imageUrl
            })
            .catch(error => {
                this.$store.dispatch('errorNotification', { msg: 'No se pudo guardar imagen', error: error })
                console.log(error)
            })
            .finally(() => {
                this.loadingUpdateImage = false
            })
        },

        viewColorSelector() {
            this.colorSelector = true
            this.selectColor = this.deviceColor
        },

        setColor () {
            this.deviceColor = this.selectColor
            this.colorSelector = false
            this.updateDevice.info.color = this.selectColor
        },

        cancelColor () {
            this.colorSelector = false
        }
    },

    watch: {
        selection (newValue) {
            this.selectType(newValue)
            this.setOptionsDevices(newValue)
        },

        sensors (val) {
            this.createDeviceTree(val)

            if ( this.devicesTree.length > 0 )
                this.selection = [this.devicesTree[0].id]
        },
            

        displayRank (val) {
            if ( val < 1 )
                this.displayRank = 1

            if ( val > 10)
                this.displayRank = 10
                
            this.updateDevice.info.displayRank = this.displayRank
        }
        
    },

    created () {
        this.createDeviceTree(this.sensors)
        this.$store.dispatch('pullOptionsDevices')
    }
  }
</script>
